<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
};
</script>

<style lang="scss">

@import 'assets/sass/_variables.scss';

//TODO: UPDATE THIS! this is just for testing.

body{
  // background-color: $gray-light;
  background-image: linear-gradient(rgba($white, 0.7),rgba($white, 0.7)),
                    url("assets/img/bg_map.svg");
  background-size: cover;
  background-position: top;  
}

</style>
